import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ParentManagerService {
  public pending = new Map<string, (value: unknown) => void>();
  public exec(code: string) {
    window.parent.postMessage(
      { type: 'exec', code: code },
      '*' // Besser: die parent-Origin eintragen!
    );
  }

  public get(code: string): Promise<unknown> {
    const requestId = crypto.randomUUID();
    return new Promise(resolve => {
      this.pending.set(requestId, resolve);
      window.parent.postMessage(
        { type: 'exec-get', code, requestId },
        '*'
      );
    });
  }
}
